// 原来写在index.html里的
import { isMiniProgram } from "./util";

var ISQQ = false;

// 判断浏览器加载地图
(function() {
  // 提取url query参数
  function getUrlParams(url) {
    url = url.substr(url.indexOf("?") + 1);
    var arr = url.split("&");
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
      var key = arr[i].split("=")[0];
      var val = arr[i].split("=")[1];
      obj[key] = val;
    }
    return obj;
  }

  // 动态加载js
  function addJs(path) {
    // 本地调试兼容
    if (typeof checkWebview === "undefined") {
      window.ISWEBVIEW = null;
      window.checkWebview = function(fn) {
        // 微信小程序标识
        fn(false);
      };
      return;
    }
    isMiniProgram(function(res) {
      //h5与小程序分享通讯用到,h5里需要再次读取,所以只要有就要设置
      var token = getUrlParams(window.location.href)["miniappToken"];
      var lon_lat = getUrlParams(window.location.href)["lon_lat"];
      if (token) {
        localStorage.setItem("miniappToken", token);
      }
      if (lon_lat) {
        sessionStorage.setItem("lon_lat", lon_lat);
      }
      if (res) {
        // 缓存小程序token和经纬度
        // var token = getUrlParams(window.location.href)["miniappToken"];
        // var lon_lat = getUrlParams(window.location.href)["lon_lat"];
        // if (token) {
        //   localStorage.setItem("miniappToken", token);
        // }
        // if (lon_lat) {
        //   sessionStorage.setItem("lon_lat", lon_lat);
        // }
        return;
      }
      if (!path || path.length === 0) {
        throw new Error('argument "path" is required !');
      }
    });
  }

  var xyUrl = [
    "https://api.map.baidu.com/api?ak=Gl2ghv7iHfbFBFvRT1K895muGm6bnxT6&v=2.0",
    "https://api.map.baidu.com/getscript?v=2.0&ak=Gl2ghv7iHfbFBFvRT1K895muGm6bnxT6&services=&t=20180629105706"
  ];
  addJs(xyUrl);
})();
